import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LoginCard from "../components/login/LoginCard";
import { emailSignIn, googleSignIn } from "../firebase";
import { useSnack } from "../contexts/AlertContext";

const LoginPage = () => {
  const setSnack = useSnack();
  const navigate = useNavigate();

  const handleEmailSignIn = async (data) => {
    const { email, password } = data;

    try {
      await emailSignIn(email, password);
      navigate("/record");
      setSnack({
        open: true,
        type: "success",
        message: "Successfully logged in"
      });
    } catch (e) {
      switch (e.code) {
        case "auth/wrong-password":
          setSnack({
            open: true,
            type: "error",
            message: "Wrong password. Check your password, and try again."
          });
          break;
        default:
          setSnack({
            open: true,
            type: "error",
            message:
              e?.code || "An unknown error occured. Please try to login again"
          });
      }
    }
  };

  const handleGoogleSignIn = async () => {
    await googleSignIn();
    navigate("/record");
    setSnack({
      open: true,
      type: "success",
      message: "Successfully logged in"
    });
  };

  return (
    <Box sx={{ marginX: "auto", marginTop: "20%", maxWidth: 600 }}>
      <LoginCard
        onEmailSignIn={handleEmailSignIn}
        onGoogleSignIn={handleGoogleSignIn}
      />
    </Box>
  );
};

export default LoginPage;
